import { css } from '@emotion/react';

const chargePanelStyles = {
    infoBlock: css({
        position: 'relative',
        width: '50%',
        padding: '10px 0',
        boxSizing: 'border-box',
    }),
    infoBlockTitle: css({
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '10px',
        color: '#000000',
        opacity: 0.5,
    }),
    infoBlockValue: css({
        display: 'inline',
        alignItems: 'flex-end',
        fontWeight: 700,
        fontSize: '15px',
        lineHeight: '15px',
        color: '#000000',
        '@media (min-width: 600px)': {
            fontSize: '20px',
        },
    }),
    infoBlockValueSymbol: css({
        display: 'inline',
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '10px',
        color: '#000000',
        paddingLeft: '4px',
        verticalAlign: 'baseline',
    }),
    infoFinishValue: css({
        display: 'inline',
        verticalAlign: 'baseline',
        fontWeight: 700,
        fontSize: '15px',
        lineHeight: '15px',
        color: '#000000',
    }),
    infoFinishValueSymbol: css({
        display: 'inline',
        fontWeight: 400,
        fontSize: '15px',
        lineHeight: '15px',
        color: '#000000',
        paddingLeft: '4px',
    }),
    row: css({
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        marginBottom: '8px',
        width: '100%',
    }),
    businessInfo: css({
        padding: '2rem 1rem',
        width: '100%',
        textAlign: 'center',
    }),
    downloadLink: css({
        padding: '16px',
        color: '#fff',
        backgroundColor: '#000',
        textDecoration: 'none',
        fontWeight: 600,
        fontSize: 15,
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        maxWidth: 400,
        width: '100%',
        margin: '0 15px',
        justifyContent: 'center',
    }),
    downloadReceipt: css({
        marginRight: 8,
    }),
    finishBlock: css({
        padding: '8px 0',
        // marginBottom: 20,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        backgroundColor: '#FFFFFF',
        borderRadius: 8,

        ['&:last-of-type']: {
            marginBottom: 0,

            ['& > div:last-of-type']: {
                borderTop: '1px solid #F4FAFF',
                paddingTop: 10,
            },

            ['& div:last-of-type div']: {
                fontWeight: 700,
            },
        },
    }),
    finishBlockRow: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',

        ['&:not(:last-of-type)']: {
            marginBottom: 10,
        },
    }),
    finishBlockTitle: css({
        fontSize: '15px',
        color: '#000000',
        fontWeight: 400,
        lineHeight: '20px',
    }),
    businessCardInfo: css({
        color: '#000000',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
    }),
    businessCardInfoTitle: css({
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#000000',
    }),
    transactionDate: css({
        fontWeight: 300,
        fontSize: '13px',
        lineHeight: '14px',
        color: '#000000',
    }),
    costBreakdownTitle: css({
        fontSize: '10px',
        color: '#000000',
        fontWeight: 700,
        textTransform: 'uppercase',
        opacity: 0.5,
        width: '100%',
        textAlign: 'left',
        margin: '10px 0 0'
    })
};

export default chargePanelStyles;
